var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 35,
    viewBox: "0 0 2.72 2.36",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09.59c.22-.06-.45-.71.25-.57.22.05.53.16.81.25.84.28.7.27-.08 1.29-.31.4-.45.53-.63-.02-.03-.09-.03-.16-.12-.15-.86.11-.88 1.05-1.19.97-.36-.1.06-1.53.96-1.77z",
    fill: "#000"
  })));
};

export default SvgShare;